import Vue from 'vue'
// 导入组件
import DownLoadFileDialog from './Dialog.vue'
// 使用基础 Vue 构造器，创建一个“子类”
const DownLoadFileConstructor = Vue.extend(DownLoadFileDialog)

let downLoadFileInstance = null
/**
 * 初始化下载文件进度条
 * @param {object | array} fileInfo 文件信息
 */
const initInstanceFileDetail = (fileInfo) => {
  downLoadFileInstance = new DownLoadFileConstructor({
    el: document.createElement('div'),
    data () {
      return {
        fileInfo
      }
    }
  })
}
/**
 * 文件详情文件 Promise 函数
 * @returns {Promise} 抛出确认和取消回调函数
 */
const downLoadFileDialog = (obj) => {
  // 非首次调用服务时，在 DOM 中移除上个实例
  if (downLoadFileInstance !== null) {
    document.body.removeChild(downLoadFileInstance.$el)
  }
  let { fileInfo } = obj
  return new Promise((reslove) => {
    initInstanceFileDetail(fileInfo)
    downLoadFileInstance.callback = (res) => {
      reslove(res)
      // 服务取消时卸载 DOM
      if (res === 'cancel' && downLoadFileInstance !== null) {
        document.body.removeChild(downLoadFileInstance.$el)
        downLoadFileInstance = null
      }
    }
    document.body.appendChild(downLoadFileInstance.$el) //  挂载 DOM
    Vue.nextTick(() => {
      downLoadFileInstance.visible = true //  打开对话框
    })
  })
}

export default downLoadFileDialog
